import { ReactComponent as InstagramIcon } from 'images/icons/social_icons/Instagram.svg';
import { ReactComponent as FacebookIcon } from 'images/icons/social_icons/Facebook.svg';
import { ReactComponent as TwitterIcon } from 'images/icons/social_icons/X.svg';
import { ReactComponent as LinkedInIcon } from 'images/icons/social_icons/Linkedin.svg';
import { ReactComponent as RedditIcon } from 'images/icons/social_icons/Reddit.svg';
import { ReactComponent as TelegramIcon } from 'images/icons/social_icons/Telegram (1).svg';
import { ReactComponent as TiktokIcon } from 'images/icons/social_icons/TikTok.svg';
import { ReactComponent as YouTubeIcon } from 'images/icons/social_icons/Youtube.svg';
import { ReactComponent as ThreadsIcon } from 'images/icons/social_icons/threads-logo.svg';

const socialAccounts = {
    instagram: { Icon: InstagramIcon, color: "#833ab4" },
    facebook: { Icon: FacebookIcon, color: "#3C5A93" },
    twitter: { Icon: TwitterIcon, color: "#20A2EB" },
    linkedin: { Icon: LinkedInIcon, color: "#0478B0" },
    reddit: { Icon: RedditIcon, color: "#FF4221" },
    telegram: { Icon: TelegramIcon, color: "#32A9DB" },
    tiktok: { Icon: TiktokIcon, color: "#69C9D0" },
    youtube: { Icon: YouTubeIcon, color: "#FF0000" },
    threads: { Icon: ThreadsIcon, color: "#000000" },
};

export default socialAccounts;